module.exports = __webpack_public_path__ + "static/media/loginPageBg.ae19fdee.jpg";